import "../../stylesheets/PopupRegister.css";
import React from "react";

function PopupInfo({ title = "", description = "", setOpenPopup, reloadOnClose = false }) {
  const handleClose = () => {
    if (typeof setOpenPopup === "function") setOpenPopup(false);
    if (reloadOnClose) window.location.reload();
  };

  return (
    <>
      <div className="popup-register-container">
        <div className="popup">
          <div className="lightgreen">
            <img
              src={process.env.PUBLIC_URL + "/images/stage_characters/Popup_Imagen.png"}
              alt=""
            />
          </div>
          {title ? <h1>{title}</h1> : null}
          <h2>{description}</h2>

          <button className="btn lightgreen-btn" onClick={handleClose}>
            Aceptar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupInfo;
